import React from "react";
import store from "store";
import ProviderWrapper from "./ProviderWrapper";
import AddToHomescreen from "components/AddToHomescreen";
import { OutageModel } from "store/types";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Routes from "routes";

type AppProps = {
  outageModel?: OutageModel;
};

const App = (props: AppProps) => {
  return (
    <ProviderWrapper store={store}>
      <>
        <Routes outageModel={props.outageModel} />
        <AddToHomescreen />
      </>
    </ProviderWrapper>
  );
};

export default App;
